<template>
<defaultLayout section="work-article">
  <template slot-scope="slotProps">

    <template v-if="!post">
    <!-- pre-loading item -->
    <div style="width: 100vw;height: 600px; background-color: white;" />
    </template>

    <template v-if="post">
    <div class="work-article-container">
    <component
      v-for="(module, idx) in post.modules"
      :key="`${slug}-${idx}`"
      :is="`module_${module.type}`"
      :data="module.data"
    />
    </div>
    </template>

  </template>
</defaultLayout>
</template>


<script>
import defaultLayout from '@/layouts/default';

export default {

  name: 'WorkArticle',

  metaInfo() {
    return {
      title: this.articleTitle,
    };
  },

  props: ['url', 'slug', 'workArticles'],

  components: { defaultLayout },

  data() {
    return {

      // json structure of the article
      post: null,

      isLoading: false,
      error: null,
    };
  },

  computed: {

    articleData() {
      const { slug, workArticles } = this;
      return workArticles[slug] || null;
    },

    articleTitle() {
      const { articleTileHeadline, articleModuleTitle } = this;
      return articleModuleTitle || articleTileHeadline || 'Particle Design';
    },

    articleModuleTitle() {
      const { articleData } = this;
      const modules = articleData.modules || [];
      const first = modules[0] || {};
      const data = first.data || {};
      return data.title || null;
    },

    articleTileHeadline() {
      const { articleData } = this;
      const tile = (articleData) ? articleData.tile : {};
      return tile.headline || null;
    },

  },

  methods: {

    retrieveArticleData() {
      const { articleData, slug } = this;
      if (articleData !== null) {
        this.isLoading = false;
        this.post = articleData;
      } else {
        const url = `/static/content/work/${slug}.json`;
        this.isLoading = true;
        this.post = null;
        this.$store.dispatch('loadWorkArticleData', { url })
          .then(() => {
            this.isLoading = false;
            this.error = false;
          })
          .catch((err) => {
            console.warn('ERROR loading article data', err);
            this.isLoading = false;
            this.error = true;
            this.requestRetrieveArticleData();
          });
      }
    },

    requestRetrieveArticleData() {
      const delay = 500;
      console.warn(`Will load data in ${delay} ms`);
      setTimeout(() => {
        console.warn('Attempting to load article data');
        this.retrieveArticleData();
      }, delay);
    },

  },

  watch: {

    $route: 'retrieveArticleData',

  },

  created() {
    this.retrieveArticleData();
  },

};
</script>

<style lang="scss">
@import '../styles/_mixins.scss';
@import '../styles/_typography.scss';
@import '../styles/_mixins.scss';

.section-work-article {

  /*
    this section handles "extended-desktop" mode
    it should be on all "core" pages
  */
  main {
    width: 100%;
    display: grid;

    // media query props
    grid-template-columns: 0 100vw 0;

    @include ngMq($layout--max-content-width, up) {
      grid-template-columns: 1fr $layout--max-content-width 1fr;
    }

    .work-article-container {
      grid-column: 2 / span 1;
    }
  }

  footer {
    // & > [data-module],
    & > .matter-featured {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-gap: rem(24px);
      padding: 0 rem(26px);

      @include ngMq($nbp--tablet, up) {
        grid-template-columns: repeat(12, 1fr);
        grid-gap: rem(26px);
        padding: 0 rem(42px);
      }

      @include ngMq($nbp--desktop, up) {
        grid-gap: rem(37px);
        padding: 0 rem(138px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkArticle.vue